<template>
    <div class="av-container">
        <div class="av-header">
            <div>
                <div class="av-header-title">记账凭证</div>
                <div style="display: flex;">
                    <div class="av-div-left"></div>
                    <div class="av-div-center av-header-title-line">====================</div>
                    <div class="av-div-right">
                        <div class="av-header-voucherno" v-if="accvoucherForm.header.voucherNo">No.{{ accvoucherForm.header.voucherNo }}</div>
                    </div>
                </div>
            </div>
            <div class="av-header-content">
                <div  class="av-div-left">
                    <div>所属实体：<span>{{ accvoucherForm.companyName }}</span></div>
                </div>
                <div class="av-div-center">凭证日期：<span>{{ this.timestampFormatter(accvoucherForm.header.voucherDate) }}</span></div>
                <div class="av-header-erpvoucherno av-div-right" v-if="accvoucherForm.header.erpVoucherNo">ERP NO.{{ accvoucherForm.header.erpVoucherNo }}</div>
            </div>
        </div>
        <div class="av-content">
            <div class="av-content-header av-border-b">
                <div style="width: 20%;" class="av-content-header-row av-border-r av-text-align-c"><span>摘要</span></div>
                <div style="width: 30%;" class="av-border-r">
                    <div class="av-content-header-split-row av-border-b av-text-align-c">财务</div>
                    <div style="display: flex;">
                        <div style="width: 50%;" class="av-content-header-split-row av-border-r av-text-align-c">一级科目</div>
                        <div style="width: 50%;" class="av-content-header-split-row av-text-align-c">明细科目</div>
                    </div>
                </div>
                <div style="width: 15%;" class="av-content-header-row av-border-r av-text-align-c">原币金额</div>
                <div style="width: 10%;" class="av-content-header-row av-border-r av-text-align-c">汇率</div>
                <div style="width: 25%;">
                    <div class="av-content-header-split-row av-border-b av-text-align-c">本币金额</div>
                    <div style="display: flex;">
                        <div style="width: 50%;" class="av-content-header-split-row av-border-r av-text-align-c">借方</div>
                        <div style="width: 50%;" class="av-content-header-split-row av-text-align-c">贷方</div>
                    </div>
                </div>
            </div>
            <div class="av-content-detail">
                <div v-for="(detail, index) in accvoucherForm.details" :key="index">
                    <div class="av-content-detail-row av-border-b">
                        <div style="width: 20%" class="av-content-detail-row-h av-border-r">
                            <div class="av-text-align-l av-line-height">
                                {{ detail.chinaDesc }}
                            </div>
                        </div>
                        <div style="width: 30%;" class="av-border-r">
                            <div style="display: flex;">
                                <div style="width: 50%;" class="av-content-detail-row-h av-border-r">
                                    <div class="av-text-align-l">
                                        <div class="av-line-height">{{ detail.accountCode }}</div>
                                        <div class="av-line-height">{{ detail.accountDesc }}</div>
                                    </div>
                                </div>
                                <div style="width: 50%;" class="av-content-detail-row-h">
                                    <div class="av-text-align-l">
                                        <div class="av-line-height">{{ detail.detailAccountCode }}</div>
                                        <div class="av-line-height">{{ detail.detailAccountDesc }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="width: 15%;" class="av-content-detail-row-h av-border-r av-text-align-r">
                            <div style="padding-right: 5px;padding-top: 5px;">
                                <div class="av-line-height">{{ detail.scurrency }}</div>
                                <div class="av-line-height">{{ detail.amountDb }}</div>
                            </div>
                        </div>
                        <div style="width: 10%;" class="av-content-detail-row-h av-border-r av-text-align-r">
                            <span style="padding-right: 5px;">{{ detail.scurrency =='CNY'? '1.00000':detail.exchangeRate }}</span>
                        </div>
                        <div style="width: 25%;">
                            <div style="display: flex;">
                                <div style="width: 50%;" class="av-content-detail-row-h av-border-r av-text-align-r">
                                    <span style="padding-right: 5px;">{{ detail.amountLocalDb }}</span>
                                </div>
                                <div style="width: 50%;" class="av-content-detail-row-h av-text-align-r">
                                    <span style="padding-right: 5px;">{{ detail.amountLocalCr }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="av-content-sum av-border-b">
                <div style="width: 20%;" class="av-content-header-row av-border-r"></div>
                <div style="width: 30%;" class="av-content-header-row av-border-r"></div>
                <div style="width: 15%;" class="av-content-header-row av-border-r"></div>
                <div style="width: 10%;" class="av-content-header-row av-border-r av-text-align-c">总计：</div>
                <div style="width: 25%;" class="av-content-header-row av-text-align-r">
                    <span style="padding-right: 5px;">{{ accvoucherForm.sumAmount }}</span>
                </div>
            </div>
        </div>
        <div class="av-footer">
            <div class="av-div-left">制单人：{{ accvoucherForm.header.operater }}</div>
            <div class="av-div-center">审批人：{{ accvoucherForm.header.checker }}</div>
            <div class="av-div-right">财务主管：{{ accvoucherForm.header.treasurer }}</div>
        </div>
    </div>
</template>

<script>
    import https, { fetchPost } from '../../../../https.js';
    export default {
        props: {
            accvoucherId: Number,
            previewFlag: Boolean
        },    //  父组件传来的值
        data() {
            return {
                accvoucherForm: {
                    companyName: '',
                    header: {
                        voucherNo: '',
                        erpVoucherNo: ''
                    },
                    details: []
                }
            }
        },
        created: function() {
            if(this.accvoucherId && this.previewFlag) {
                this.getAccountVoucherDataById(this.accvoucherId);
            }
        },
        methods: {
            getAccountVoucherDataById(accvoucherId) {
                fetchPost('/archival/getAccountVoucherDataInfo', accvoucherId).then(res => {
                    if(res.data.success) {
                        let sumAmount = 0;
                        if(res.data.obj && res.data.obj.details && res.data.obj.details.length > 0) {
                            res.data.obj.details.forEach(detail => {
                                //  总计：本币借方金额
                                sumAmount += Math.abs(detail.amountLocalDb);
                                detail.amountDb = this.formatAmountSeparator(Math.abs(detail.amountDb));
                                if(detail.amountLocalDb && parseFloat(detail.amountLocalDb) != '0.00') {
                                    detail.amountLocalDb = this.formatAmountSeparator(Math.abs(detail.amountLocalDb));
                                    detail.amountLocalCr = "";
                                }
                                if(detail.amountLocalCr && parseFloat(detail.amountLocalCr) != '0.00') {
                                    detail.amountLocalDb = "";
                                    detail.amountLocalCr = this.formatAmountSeparator(Math.abs(detail.amountLocalCr));
                                }
                            });
                        }
                        this.accvoucherForm = res.data.obj;
                        this.accvoucherForm.sumAmount = this.formatAmountSeparator(sumAmount);
                    } else {
                        this.$message.error('记账凭证明细信息加载失败：' + res.data.message);
                    }
                }).catch(error => {
                    this.$message.error('记账凭证明细信息加载失败：' + error);
                });
            }
        }
    }
</script>

<style scoped>
    .av-container {
        padding: 5px;
        color: #606266;
        height: 460px;
        overflow-y: auto;
    }
    .av-header {
        padding-top: 10px;
    }
    .av-header-title {
        font-size: 24px;
        text-align: center;
    }
    .av-header-title-line {
        font-size: 17px;
        padding-top: 5px;
    }
    .av-header-voucherno {  /* 凭证号 */
        position: relative;
        bottom: 10px;
        color: red;
        font-size: 18px;
    }
    /* .av-header-erpvoucherno {
        font-size: 14px;
    } */
    .av-header-content {    /* 所属实体、凭证日期、erp凭证号 */
        width: 100%;
        display: flex;
        padding: 15px 0px;
        font-size: 12px;
    }
    .av-header-content span {
        padding-left: 5px;
    }
    .av-div-left {
        width: 35%;
        text-align: left;
    }
    .av-div-center {
        width: 30%;
        text-align: center;
    }
    .av-div-right {
        width: 35%;
        text-align: right;
    }
    .av-content {
        width: 100%;
        border: 1px solid #DCDFE6;
        border-bottom: none;
        /* overflow-y: auto; */
    }
    .av-content-header {
        display: flex;
    }
    .av-content-header-row {
        line-height: 70px;
    }
    .av-content-header-split-row {
        height: 35px;
        line-height: 35px;
    }
    .av-border-r {
        border-right: 1px solid #DCDFE6;
    }
    .av-border-b {
        border-bottom: 1px solid #DCDFE6;
    }
    .av-text-align-l {
        text-align: left;
        padding: 5px 5px 5px 10px;
    }
    .av-text-align-c {
        text-align: center;
    }
    .av-text-align-r {
        text-align: right;
    }
    .av-line-height {
        line-height: 20px;
    }
    .av-content-detail-row {
        display: flex;
    }
    .av-content-detail-row-h {
        height: 70px;
        line-height: 70px;
    }
    .av-content-sum {
        display: flex;
    }
    .av-footer {
        display: flex;
        height: 35px;
        padding-top: 10px;
        font-size: 15px;
    }
</style>